import { render, staticRenderFns } from "./legal-notice.vue?vue&type=template&id=54987f52&"
import script from "./legal-notice.vue?vue&type=script&lang=js&"
export * from "./legal-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports